import React from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Tooltip } from "@mui/material";
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import { useRouter } from "../../hooks/useRouter";
import { ROUTES } from "../../routes";
import { createClickEngagementRecorder } from "../../utils/api";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import SuperChatHistoryAction from './SuperChatHistoryAction';

const SuperChatHistory = () => {
  const { t } = useTranslation();
  const { push, location } = useRouter();
  const { roomDomain } = useWhiteboardRoom();
  const clickRecorder = createClickEngagementRecorder(roomDomain, roomDomain);
  const [isOpen, setIsOpen] = React.useState(false);

  const handleBtnClick = () => {
    clickRecorder("superchat-hostory");
    setIsOpen((prev) => !prev);
    
  };

  const isActive =
    location.pathname.includes(ROUTES.DM_PAGE) ||
    location.state?.from?.includes(ROUTES.DM_PAGE);

  return (
    <><Tooltip
      title={t("SuperChat_History")}
      placement="bottom"
      arrow
      disableInteractive
    >
      <IconButton
        aria-label="invite"
        onClick={handleBtnClick}
        color={isActive ? "primary" : "default"}
      >
        <LoyaltyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
    <SuperChatHistoryAction isOpen={isOpen} setIsOpen={setIsOpen}/>
    </>
    
  );
};

export default SuperChatHistory;
